import styled from '@emotion/styled';
import type { FC } from 'react';

/**
 * The build this tab is running, e.g. `2026.33.alpha-0-g4fc25490b`. Shown so support can ask
 * "what does it say?" instead of guessing whether someone is on an outdated build.
 *
 * Renders nothing in local dev, where no version is stamped into the HTML.
 */
export const VersionLabel: FC<{ className?: string }> = ({ className }) => {
  const version = window.__BUILD_VERSION__;
  if (!version) return null;

  return (
    <Version className={className} title={`Build version ${version}`}>
      {version}
    </Version>
  );
};

const Version = styled.span`
  font-size: 11px;
  font-family: monospace;
  opacity: 0.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
